<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/planAdmin">投放管理</BreadcrumbItem>
            <BreadcrumbItem>查看数据统计</BreadcrumbItem>
        </Breadcrumb>
        <div class="statistics">
            <br>
            <Row>
                <div style="display: inline-block;">
                    <div class="box">
                        <div class="title">                     
                            投放天数
                        </div>
                        <div class="count">
                            {{total_days}}天
                        </div>
                    </div>
                </div>
                <div style="display: inline-block;">
                    <div class="box" >
                        <div class="title">
                            PV曝光次数
                        </div>
                        <div class="count">
                            {{total_exposure_count}}次
                        </div>
                    </div>
                </div>
                <div style="display: inline-block;">
                    <div class="box">
                        <div class="title">
                            点击次数
                        </div>
                        <div class="count">
                            {{total_click_count}}次
                        </div>
                    </div>
                </div>
                <div style="display: inline-block;">
                    <div class="box">
                        <div class="title">
                            订单数
                        </div>
                        <div class="count">
                            {{order_quantity}}单
                        </div>
                    </div>
                </div>
                <div style="display: inline-block;">
                    <div class="box">
                        <div class="title">
                            订单金额
                        </div>
                        <div class="count">
                            {{total_order_amount}}元
                        </div>
                    </div>
                </div>
            </Row>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">数据趋势</span>
            </Row>
            <Row class="row">
                <Col span="8">
                    <Select v-model="model" style="width:200px" @on-change="handleChange">
                        <Option value="show_count">PV曝光量</Option>
                        <Option value="click_count">点击数</Option>
                        <Option value="order_quantity">订单数</Option>
                    </Select>
                </Col>
            </Row>
            <div id="echart"></div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import * as echarts from 'echarts';
import{planStatistics}from "@/request/api"
export default {
    name: 'planStatistics',
    components: {
        
    },
    data () {
        return {
            total_days: 0,
            total_exposure_count: 0,
            total_click_count: 0,
            order_quantity: 0,
            total_order_amount: 0,
            model: 'show_count',
            exposure_connt_list: [],
            click_connt_list: [],
            order_quantity_list: [],
            date_list: [],
            data: [],
            chart_name: 'PV曝光量'
        }
    },
    methods:{
        getData(plan_id){
            planStatistics({plan_id}).then(res=>{
                if(res.data.code==200){
                    this.total_days=res.data.data.statistics_data.total_days
                    this.total_exposure_count=res.data.data.statistics_data.total_exposure_count
                    this.total_click_count=res.data.data.statistics_data.total_click_count
                    this.order_quantity=res.data.data.statistics_data.order_quantity
                    this.total_order_amount=res.data.data.statistics_data.total_order_amount
                    this.exposure_connt_list=res.data.data.statistics_data.daily_flow_30.exposure
                    this.click_count_list=res.data.data.statistics_data.daily_flow_30.click
                    this.order_quantity_list=res.data.data.statistics_data.daily_flow_30.order
                    this.date_list=res.data.data.statistics_data.daily_flow_30.date
                    this.data=res.data.data.statistics_data.daily_flow_30.exposure
                    this.drawChart()
                }else{
                    this.$Message.success(res.data.msg);
                }
            })
        },
        drawChart(){
            var Echart = echarts.init(document.getElementById('echart'));
            var option1  = {
                xAxis: {
                    type: 'category',
                    data: this.date_list
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.data,
                    type: 'bar',
                    name: this.chart_name
                }],
                legend: {
                    show: true,
                    x:'center',
                    y:'bottom'
                },
                grid: {
                    top: 30
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                }
            };

            Echart.setOption(option1);
            window.addEventListener("resize", () => { Echart.resize();});
        },
        handleChange(value){
            if(value=='show_count'){
                this.chart_name = 'PV曝光量'
                this.data = this.exposure_connt_list
                this.drawChart()
            }else if(value=='click_count'){
                this.chart_name = '点击数'
                this.data = this.click_count_list
                this.drawChart()
            }else if(value=='order_quantity'){
                this.chart_name = '订单数'
                this.data = this.order_quantity_list
                this.drawChart()
            }
        }
    },
    created() {
        Cookies.set('active_name', '3');
        this.getData(this.$route.query.plan_id)
    },
    mounted(){
        Cookies.set('active_name', '1');
    }
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-height: 120px;
  min-height: 120px;
  /* border:1px solid; */
  background: white;
}
.statistics{
  width: 100%;
  /* border:1px solid; */
  background: white;
  margin-top: 20px;
}
.row{
  margin: 10px 20px 10px;
}
.box{
  width: 200px;
  height: 120px;
  border:1px solid;
  margin: 0px 0px 20px 20px;
}
.box .count{
  width: 100%;
  height: 70%;
  line-height: 60px;
  text-align: center;
  /* font-display: center; */
  font-size: 24px;
}
.box .title{
    text-align: left;
    font-size: 14px; 
    margin:10px 10px 0px;
}
#echart{
    margin:20px 20px 0px;
    width: 100%;
    height: 400px
}
</style>



// WEBPACK FOOTER //
// src/views/Plan/PlanStatistics.vue